import { render, staticRenderFns } from "./AnswerMiniview.vue?vue&type=template&id=455d9f8f"
import script from "./AnswerMiniview.vue?vue&type=script&lang=js"
export * from "./AnswerMiniview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports